/**
 * WASSER Admin - Typography Configuration
 * B2B-стиль: читаемый, профессиональный
 *
 * Mobile-First подход:
 * - Базовые стили = мобильные
 * - Увеличиваем размеры через min-width
 */

import * as tokens from '@shared/theme/tokens.js';

const typography = {
  fontFamily: [
    'Inter',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
  ].join(','),

  // Mobile-First: базовые размеры - мобильные, увеличиваем на desktop
  h1: {
    fontWeight: tokens.typography.fontWeight.bold,
    fontSize: tokens.typography.fontSize.h3, // mobile base
    lineHeight: tokens.typography.lineHeight.tight,
    letterSpacing: tokens.typography.letterSpacing.tight,
    '@media (min-width: 600px)': {
      fontSize: tokens.typography.fontSize.h2, // tablet+
    },
  },
  h2: {
    fontWeight: tokens.typography.fontWeight.semibold,
    fontSize: tokens.typography.fontSize.h4, // mobile base
    lineHeight: tokens.typography.lineHeight.tight,
    letterSpacing: tokens.typography.letterSpacing.tight,
    '@media (min-width: 600px)': {
      fontSize: tokens.typography.fontSize.h3, // tablet+
    },
  },
  h3: {
    fontWeight: tokens.typography.fontWeight.semibold,
    fontSize: tokens.typography.fontSize.h5, // mobile base
    lineHeight: tokens.typography.lineHeight.tight,
    letterSpacing: tokens.typography.letterSpacing.normal,
    '@media (min-width: 600px)': {
      fontSize: tokens.typography.fontSize.h4, // tablet+
    },
  },
  h4: {
    fontWeight: tokens.typography.fontWeight.semibold,
    fontSize: tokens.typography.fontSize.xl, // mobile base
    lineHeight: tokens.typography.lineHeight.normal,
    '@media (min-width: 600px)': {
      fontSize: tokens.typography.fontSize.h5, // tablet+
    },
  },
  h5: {
    fontWeight: tokens.typography.fontWeight.medium,
    fontSize: tokens.typography.fontSize.lg, // mobile base
    lineHeight: tokens.typography.lineHeight.normal,
    '@media (min-width: 600px)': {
      fontSize: tokens.typography.fontSize.xl, // tablet+
    },
  },
  h6: {
    fontWeight: tokens.typography.fontWeight.medium,
    fontSize: tokens.typography.fontSize.md, // mobile base
    lineHeight: tokens.typography.lineHeight.normal,
    '@media (min-width: 600px)': {
      fontSize: tokens.typography.fontSize.lg, // tablet+
    },
  },

  body1: {
    fontSize: tokens.typography.fontSize.md, // keep 16px for readability
    lineHeight: tokens.typography.lineHeight.relaxed,
  },
  body2: {
    fontSize: tokens.typography.fontSize.sm,
    lineHeight: tokens.typography.lineHeight.normal,
  },

  subtitle1: {
    fontSize: tokens.typography.fontSize.md,
    fontWeight: tokens.typography.fontWeight.medium,
    lineHeight: tokens.typography.lineHeight.normal,
  },
  subtitle2: {
    fontSize: tokens.typography.fontSize.sm,
    fontWeight: tokens.typography.fontWeight.medium,
    lineHeight: tokens.typography.lineHeight.normal,
  },

  button: {
    textTransform: 'none',
    fontWeight: tokens.typography.fontWeight.semibold,
    fontSize: tokens.typography.fontSize.sm,
  },

  caption: {
    fontSize: tokens.typography.fontSize.xs,
    lineHeight: tokens.typography.lineHeight.normal,
  },

  overline: {
    fontSize: tokens.typography.fontSize.xs,
    fontWeight: tokens.typography.fontWeight.semibold,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
};

export default typography;
